/**
 * Ki latta az uzenetet?
 *
 * A szerver csak a POZICIOT tarolja csatornatagonkent (`lastReadSeq`), nem
 * uzenetenkenti visszajelzest. Ez a szabaly forditja at a poziciot arra a
 * kerdesre, hogy egy KONKRET uzenetet ki olvasott el.
 *
 * Azert van a kozos csomagban, mert ez nem megjelenites, hanem szabaly: a
 * "ki latta" kerdesre egyetlen valasz letezhet, es azt gepileg akarjuk
 * ellenorizni.
 */
/**
 * Az uzenetet latok listaja - a KULDOT nem szamolva.
 *
 * A kuldo kiszurese nem apróság: sajat magunk termeszetesen "elolvastuk" a
 * sajat uzenetunket, es enelkul minden uzenet azonnal "latta" allapotba
 * kerulne - a jelzes semmit nem mondana.
 */
export function seenBy(positions, seq, senderId) {
    if (!positions)
        return [];
    return Object.entries(positions)
        .filter(([userId, lastReadSeq]) => userId !== senderId && lastReadSeq >= seq)
        .map(([userId]) => userId);
}
//# sourceMappingURL=read-receipt.js.map